import React from "react";

import Loader from "@/ui/atoms/Loader";

export type ViewAuthCallbackParams = {
    useState: () => {
        isLoading: boolean;
        error: unknown;
    };
    useCases: () => {
        onMount: () => void;
    };
};

export const createViewAuthCallback = ({
    useState,
    useCases,
}: ViewAuthCallbackParams) => {
    const ViewAuthCallback = () => {
        const { onMount } = useCases();
        const { error, isLoading } = useState();

        const isAlreadyMountedRef = React.useRef(false);
        React.useEffect(() => {
            if (isAlreadyMountedRef.current) return;

            isAlreadyMountedRef.current = true;
            onMount();
        }, [onMount]);

        if (isLoading) {
            return <Loader label={"Authenticating..."} />;
        }

        if (error !== undefined && error !== null) {
            throw error;
        }

        return <Loader label={"Redirecting..."} />;
    };

    return ViewAuthCallback;
};
